



















































































































































import { Vue, Component, Prop } from 'vue-property-decorator';

const { AgGridVue } = require('ag-grid-vue');
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  ColDef,
  ColumnApi,
  CellClickedEvent,
} from 'ag-grid-community';

import { Snotify } from '@/snotify/Snotify';
import { LoadingService } from '@/services/loadingService';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';

import { DataApi, DevicesApi } from './models/Add.model';
import { fetchAdd } from './fetchAdd';
import AddEquipo from './AddEquipos.vue';
import MenuItem from '@/components/MenuItem.vue';
import { Funcionalidades } from '@/config/funcionalidades';
import {
  codigoAccionesMenuItem as allActions,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import store from '@/store';
import { actionsEvent } from '@/setup';
import Confirmation from '@/components/Confirmation.vue';

@Component({
  components: {
    GridComponent: AgGridVue,
    DatePicker,
    AddEquipo,
    MenuItem,
    Confirmation,
  },
})
export default class AddModalAgregarEquipos extends Vue {
  @Prop({ required: true, default: true }) dialog!: boolean;
  @Prop({ required: true, default: null }) data!: DataApi;

  // Grid
  columnApi: ColumnApi = null;
  gridOptions: GridOptions = null;
  gridEvent: GridReadyEvent = null;
  gridApi: GridApi = null;
  columnDefs: ColDef[] = [];
  deviceList: DevicesApi[] = [];

  dialogPopUp: boolean = false;
  modalDeviceList: boolean = false;
  loading: boolean = false;

  quickSearch: string = '';
  now: string = moment().format('YYYY-MM-DD');

  objParam: {
    despachador?: string;
    fecha_despachador?: moment.Moment;
  } = {};
  users: any = [];
  propietario: string = '';
  timeout: { timeout: number } = { timeout: 3000 };
  validateFieldEmpty: Record<string, boolean> = {
    fecha_despacho: false,
  };

  readonly $snotify: Snotify = null;
  readonly loadingService: LoadingService = new LoadingService();
  readonly funcionalidades: Funcionalidades = Funcionalidades.ModalAdd;
  readonly codigoAccionesMenuItem: number[] = Object.values(allActions);

  eliminar: PermisoAccion = {
    accionCodigo: 5,
    visible: false,
  };
  readonly accionesTotales: PermisoAccion[] = [this.eliminar];

  async mounted() {
    try {
      this.loading = true;
      this.loadingService.showLoading(null, 'getUser');

      await this.getUser();
      this.objParam.despachador = this.data.despachado_por;

      this.objParam.fecha_despachador = this.data.fecha_despacho
        ? moment(this.data.fecha_despacho)
        : moment();
      this.validateFieldEmpty.fecha_despacho = !!this.data.fecha_despacho;
    } catch (error) {
      console.error('Error: ', error);
    } finally {
      this.loading = false;
      this.loadingService.hideLoading('getUser');
    }
  }

  async getUser() {
    const userId = JSON.parse(
      window.localStorage.getItem('user').replace(/'/g, '"')
    ).id;

    try {
      const result = await fetchAdd({
        endpoint: 'get_user',
        body: { user_id: userId, add: this.data.nombre_add },
      });
      const {
        MENSAJE_RESPUESTA,
        CODIGO_RESPUESTA,
        USERS,
        PROPIETARIO,
      } = result.data;
      const cod: number = Number(CODIGO_RESPUESTA);
      if (cod !== 1) {
        this.$snotify.error(MENSAJE_RESPUESTA, { ...this.timeout });
        return;
      }
      //this.objParam.despachador = USER[0].nombre;
      this.users = USERS;
      this.propietario = PROPIETARIO;
      this.objParam.despachador = PROPIETARIO;
    } catch (error) {
      console.error('Error validando el usaurio: ', error);
    }
  }

  actions() {
    actionsEvent.onEliminar(this.handleDeleteDevice);
  }

  constructor() {
    super();
    this.actions();
    this.columnDefs = this.colsGrid();

    this.gridOptions = {
      columnDefs: this.columnDefs,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      onGridReady: this.handleMainGridReady,
    };
  }

  handleMainGridReady(event: GridReadyEvent): void {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    this.gridApi.setRowData(this.deviceList);
    this.gridApi.setDomLayout('autoHeight');
  }

  handleSearch(): void {
    if (!this.gridApi) {
      return;
    }
    this.gridApi.setQuickFilter(this.quickSearch);
    this.gridApi.setDomLayout('autoHeight');
  }

  handleSelected(devices: DevicesApi[]): void {
    for (const device of devices) {
      if (!this.deviceList.includes(device)) {
        this.deviceList.push(device);
        this.reloadGrid(this.deviceList);
      }
    }
  }

  handleChangeDate(): void {
    // Forzar la actualización de la fecha
    this.$forceUpdate();
  }

  reloadGrid(data: DevicesApi[]): void {
    this.gridApi.setRowData(data);
    this.gridApi.setDomLayout('autoHeight');
  }

  handleDeleteDevice(params: { data: DevicesApi }): void {
    const serieNumero: string = params.data.serienumero;
    this.deviceList = this.deviceList.filter(
      serie => !serieNumero.includes(serie.serienumero)
    );
    this.reloadGrid(this.deviceList);
  }

  private colsGrid() {
    const cols = [
      { id: 'serienumero', field: 'Serie Número' },
      { id: 'tipoeqname', field: 'Equipo' },
      { id: 'simserienumero', field: 'SIM' },
      { id: 'simestado', field: 'Estado SIM' },
      { id: 'telconame', field: 'Telco' },
    ];
    const columns: ColDef[] = cols.map(col => ({
      headerName: col.field,
      field: col.id,
      cellStyle: { textAlign: 'left' },
      resizable: false,
      sortable: true,
      width: 200,
      minWidth: 200,
    }));

    columns.push({
      headerName: 'Acciones',
      width: 120,
      minWidth: 120,
      sortable: false,
      resizable: false,
      filter: false,
      enablePivot: false,
      field: 'id',
      cellRendererFramework: MenuItem,
      cellRendererParams: () => ({
        funcionalidad: this.funcionalidades,
        codigoAccionesMenuItem: this.codigoAccionesMenuItem,
        usuario: store.state.user,
      }),
      colId: 'params',
      rowDrag: false,
      pinned: 'right',
      lockVisible: true,
      suppressMovable: true,
      getQuickFilterText: () => '',
      cellStyle: { textAlign: 'center' },
    });

    return columns;
  }

  handleAdd(): void {
    if (!this.objParam.despachador) {
      this.$snotify.error('El campo Despachado Por es un campo obligatorio', {
        ...this.timeout,
      });
      return;
    }
    if (!this.deviceList.length) {
      this.$snotify.error('Debe agregar por lo menos un dispositivo', {
        ...this.timeout,
      });
      return;
    }
    this.addDevice();
  }

  handleClosed({ reload = false }): void {
    //this.data = {};
    this.$emit('cerrar', reload);
  }

  handleClosedModalAddDevices(): void {
    // Remover las acciones para evitar bucles de notificaciones
    actionsEvent.removeListeners();
    // Volver a llamarlas
    this.actions();
    this.modalDeviceList = false;
  }

  cargarDispositivosTodos() {
    this.modalDeviceList = true;
  }

  handleFechaDespachadorChange(newFecha: any) {
    this.objParam.fecha_despachador = moment(newFecha);
  }

  handlePopUp(): void {
    if (this.validateFieldEmpty.fecha_despacho && !this.deviceList.length) {
      this.handleClosed({});
      return;
    }
    this.dialogPopUp = true;
  }

  showPopuP(confirmation: boolean): void {
    this.dialogPopUp = !this.dialogPopUp;
    if (confirmation) {
      this.handleClosed({});
    }
  }

  async addDevice(): Promise<void> {
    this.loadingService.showLoading();
    const self = this;
    return await fetchAdd({
      endpoint: 'add_devices',
      body: {
        device_list: self.deviceList,
        data: self.data,
        params: self.objParam,
      },
    })
      .then(resp => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = resp.data;
        const cod: number = Number(CODIGO_RESPUESTA);
        if (cod !== 1) {
          throw new Error(MENSAJE_RESPUESTA);
        }
        self.$snotify.success(MENSAJE_RESPUESTA, { ...self.timeout });
        self.handleClosed({ reload: true });
      })
      .catch((err: Error) => {
        if (
          err instanceof Error &&
          err.message &&
          err.message !== 'Network Error'
        ) {
          self.$snotify.error(err.message, { ...self.timeout });
          return;
        }
        self.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { ...self.timeout }
        );
      })
      .finally(() => self.loadingService.hideLoading());
  }
}
